var map = {
	"./20200721-Oracle SQL Certificate.jpg": 11,
	"./20200721-Oracle SQL Certificate.pdf": 12,
	"./20240504-SPLK-1002 Certificate.jpg": 13,
	"./20240504-SPLK-1002 Certificate.pdf": 14,
	"./20250524-AZ400.jpg": 15,
	"./20250524-AZ400.pdf": 16,
	"./20251005-AZ204.jpg": 17,
	"./20251005-AZ204.pdf": 18,
	"./20290527-PMP Certfication.jpg": 19,
	"./20290527-PMP Certfication.pdf": 20
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10;